export default {
  namespaced: true,
  state: {
    plans: [
      {
        id: "starter",
        name: "Starter",
        stripe: {
          live: {
            plan: "plan_GFahafI0tjZTyu",
            product: "prod_GFahfk8up515mY",
          },
          dev: {
            plan: "plan_GFafa9GlSiWXx3",
            product: "prod_G3MhjSzhO92Q27",
          },
        },
        price: 29,
        items: [
          {
            icon: "users",
            name: "Team Members",
            details: "1 team member",
          },
          {
            icon: "map-marker-alt",
            name: "Locations",
            details: "1 location",
          },
          {
            icon: "desktop",
            name: "Ads",
            details: "Unlimited",
          },
        ],
      },
      {
        id: "standard",
        name: "Standard",
        stripe: {
          live: {
            plan: "plan_GFahbWGvmFY0y2",
            product: "prod_GFahfk8up515mY",
          },
          dev: {
            plan: "plan_G3MifQAx2v25k4",
            product: "prod_G3MhjSzhO92Q27",
          },
        },
        price: 99,
        items: [
          {
            icon: "users",
            name: "Team Members",
            details: "5 team members",
          },
          {
            icon: "map-marker-alt",
            name: "Locations",
            details: "5 locations",
          },
          {
            icon: "desktop",
            name: "Ads",
            details: "Unlimited",
          },
        ],
      },
      {
        id: "preminum",
        name: "Premium",
        stripe: {
          live: {
            plan: "plan_GFahoNIsTGfLPp",
            product: "prod_GFahfk8up515mY",
          },
          dev: {
            plan: "plan_G3MjMitW6cpbTT",
            product: "prod_G3MhjSzhO92Q27",
          },
        },
        price: 299,
        items: [
          {
            icon: "users",
            name: "Team Members",
            details: "50 team members",
          },
          {
            icon: "map-marker-alt",
            name: "Locations",
            details: "20 Locations",
          },
          {
            icon: "desktop",
            name: "Ads",
            details: "Unlimited",
          },
        ],
      },
    ],
  },
  mutations: {},
  actions: {},
};
